export default Object.freeze({
  INVOICE: 1,
  PURCHASE_ORDER: 2
})
